export default {
  dictRuStep2,
};

export const dictRuStep2 = {
  DetailAddressHeader: 'Уточните ваш адрес',
  DetailContactsHeader: 'Укажите контактные данные',
  ShipperAddress: 'Адрес отправителя',
  ShipperAddressIsAgency: 'Адрес отправителя (для указания в накладной)',
  ReceiverAddress: 'Адрес получателя',
  SenderContacts: 'Отправитель',
  ReceiverContacts: 'Получатель',
  ReceiverContactsYou: 'Получатель (вы)',
  Address: 'Адрес',
  Name: 'Фамилия, Имя, Отчество/ИП',
  CompanyName: 'Наименование компании',
  INN: 'ИНН',
  LegalTitle: 'Плательщиком является юридическое лицо',
  LegalName: 'Полное название компании плательщика',
  LegalNameTooltip:
    'Название организации должно быть указано на русском языке и с указанием организационно-правовой формы компании, например ООО Планета, ПАО Фотострана, ИП Никитюк Л.Ю.',
  LegalInn: 'ИНН компании плательщика',
  Phone: 'Телефон',
  Worktime: 'Режим работы',
  Email: 'Email',
  ResidentRF: 'Нерезидент РФ',
  DeliveryType: 'Что вы хотите отправить?',
  DeliveryTypeText: 'Пожалуйста, подробно укажите,что именно вы отправляете.',
  DeliveryTypeTextAbroad:
    'Пожалуйста, подробно укажите, что именно вы отправляете на английском языке (не более 65 символов).',
  CourierNote: 'Примечание для курьера',
  DeliveryTypeHeader: 'Вид доставки',
  CourierOrder: 'Оформление вызова курьера онлайн',
  WalkOrder: 'Отправка груза из офиса DHL',
  ChooseServicePoint: 'Выберите отделение DHL',
  SingleServicePoint: 'Отделение DHL',
  Documents: 'Документы',
  NonDocuments: 'Грузы',
  InternationalWarnTitle: 'Международная отправка грузов',
  InternationalWarnJurik:
    'Груз со стоимостью более 1000 евро невозможно оформить на сайте. Пожалуйста, получите дополнительную информацию по телефону: +7 (495) 961-10-67.',
  InternationalWarnNonJurik:
    'Груз со стоимостью более 1000 евро невозможно оформить на сайте. Пожалуйста, получите дополнительную информацию по телефону: +7 (495) 961-10-67.',
  BookCourier: 'Вызвать курьера',
  CreateAnAwb: 'Оформить накладную',
  declaredTitle: 'Стоимость груза для таможенного оформления',
  RecalculationDeclared: 'Пересчет стоимости груза в Евро будет произведен в день регистрации таможенного документа. Возможно выставление счетов за брокерские услуги в стране отправления, если стоимость груза превышает 1000 евро.',
  ExtrasTitle: 'Дополнительные услуги',
  PaymentsTitle: 'Выберите способ оплаты',
  CashPaymentTitle: 'Оплата наличными',
  CashPaymentOffice: 'Оплата наличными в офисе',
  CashPaymentCourier: 'Оплата наличными курьеру',
  CardPaymentTitle: 'Оплата картой',
  CardPaymentDescription: 'Оплата картой в офисе',
  OnlineCardPaymentTitle: 'Оплата онлайн',
  OnlineCardPaymentDescription: 'Оплата онлайн на сайте.',
  AcceptText: 'Я подтверждаю согласие с(-на)',
  Conditions: 'Условиями доставки грузов DHL Express',
  ConditionsDiscount: 'Условиями предоставления специальных предложений',
  And: ' и',
  ProcessingPersonalData: 'обработку персональных данных',
  ShippingCost: 'Стоимость доставки',
  Delivery: 'Доставка до',
  DeliveryBy: 'Планируемый срок доставки до',
  Deliver: 'Доставить',
  Slower: 'медленнее',
  Faster: 'быстрее',
  PriceLessThenMinPrice: 'Страховка предоставляется только при стоимости выше {minPrice} рублей',
  PriceMoreThenMaxPrice: 'Страховка предоставляется только при стоимости ниже {maxPrice} рублей',
  DeclaredValue: 'Стоимость груза для таможенного декларирования',
  DeclaredValueDesc:
    'Обратите внимание, что стоимость должна совпадать со стоимостью, указанной в сопроводительных документах (инвойсе).',
  Currency: 'Валюта',
  FreeExtraCharge: 'Бесплатно',
  From: 'Откуда',
  To: 'Куда',
  PackageDetailTitle: 'Пожалуйста, внимательно проверьте детали доставки',
  PackageDetailReminderDimensions:
    'Убедитесь, что вы максимально точно указали габариты и вес груза. Изменить параметры груза вы можете',
  Here: 'здесь',
  PackageDetailSend: 'Вы отправляете',
  PackageDetailContacts: 'Контактные данные',
  PackageDetailDeliveryTime: 'Планируемый срок доставки до',
  PackageDetailDateOfShipmentServicePoint:
    'Дата оформления груза в сервисном отделении',
  PackageDetailDateOfShipmentCourier:
    'Дата и время приезда курьера для приема груза',
  PackageDetailIncludingServices: 'включая все дополнительные услуги',
  ReminderApproximateTime:
    'Указанные дата и время приезда курьера являются ориентировочными. Точные дата и время приезда курьера будут согласованы с отправителем нашим сотрудником.',
  ReminderOnlinePay1:
    'На вашей карте до момента списания денежных средств будет заблокирована сумма в размере',
  Rubles: 'рублей.',
  ReminderOnlinePay2: 'Она включает в себя стоимость доставки',
  Plus: '+',
  ReminderOnlinePayReserve: 'рублей резерв.',
  ReminderOnlinePay3:
    'Списание денежных средств в рамках заблокированной суммы производится в день приема груза на основании рассчитанной сотрудником офиса стоимости доставки, после взвешивания и измерения им габаритов груза.',
  ReminderOnlinePay4:
    'Разблокировка лишней суммы будет произведена в момент списания стоимости доставки. ',
  ReminderOnlinePay5:
    'Сроки разблокировки суммы на вашей карте зависят от вашего банка.',
  ReminderPrinter:
    'Убедитесь, что у отправителя груза (если вы им не являетесь) есть принтер для печати накладной.',
  ReminderPrinterAbroad:
    'Внимание! Убедитесь, что у отправителя груза есть принтер для печати накладной. Отправитель должен распечатать накладную до прибытия курьера и отдать ее вместе с документами.',
  ReminderPrinterCargoForeign:
    'Убедитесь, что у отправителя груза (если вы им не являетесь) есть принтер для печати документов.',
  ReminderTotalPrice0:
    'Финальная стоимость доставки рассчитывается после взвешивания и измерения габаритов документов автоматизированными системами. Списание денежных средств производится следующим образом:',
  ReminderTotalPrice1:
    '1) Если заблокированной суммы достаточно – DHL производит списание финальной стоимости. Сроки разблокировки резерва зависят от вашего банка.',
  ReminderTotalPrice2:
    '2) Если заблокированной суммы недостаточно – DHL произведет списание всей заблокированной суммы и осуществляет дополнительное списание оставшейся суммы рекуррентным платежом.',
  ReminderTotalPrice3:
    'Накладная будет сформирована после предоставления вами данных вашей банковской карты и направлена вам и отправителю на электронную почту.',
  ReminderTotalPrice4:
    'Фискальный чек будет сформирован после списания денежных средств и отправлен вам на электронную почту.\n',
  AwbAndBillWillSendViaEmail:
    'Накладная будет сформирована после предоставления вами данных вашей банковской карты и направлена вам на электронную почту. Фискальный чек будет сформирован после списания денежных средств и отправлен вам на электронную почту. ',
  AwbWillSendViaEmail:
    'Накладная будет сформирована и направлена на указанный вами электронный адрес. ',
  ApcWillSendVieEmail:
    'Код заявки будет присвоен и направлен на указанный вами электронный адрес.',
  AwbWillSendViaEmailCargoForeign:
    'Документы будут сформированы и направлены на указанный вами электронный адрес. ',
  RemindSenderToPrintCourier:
    'Отправитель должен распечатать накладную до прибытия курьера и отдать ему ее вместе с грузом.',
  RemindSenderToPrintCourierCargoForeign:
    'Отправитель должен распечатать документы до прибытия курьера и отдать ему их вместе с грузом.',
  PackageDetailAgreement: 'Я являюсь владельцем карты и подтверждаю согласие с',
  PackageDetailAgreementLink: 'условиями оплаты картой.',
  RemindSenderToWalk:
    'Отправитель должен сообщить номер заявки консультанту сервисного  отделения.',
  // Ниже 2 переменные одинаковые - их не трогать, т.к. они отличаются в АНГЛ версии
  RemindSenderToPrintServicePoint:
    'Отправитель должен сообщить номер заявки консультанту сервисного отделения.',
  RemindSenderToPrintServicePointCargoForeign:
    'Отправитель должен сообщить номер заявки консультанту сервисного отделения.',
  RemindSenderToSayCode:
    'Отправитель должен сообщить код заявки консультанту сервисного отделения.',
  PayAttention:
    'В соответствии с требованиями безопасности воздушных перевозок компании DHL все грузы принимаются к отправке в открытом виде. При отправлении грузов при себе необходимо иметь паспорт гражданина Российской Федерации или действующий заграничный паспорт (для граждан других государств).',
  ReminderOnlinePayTooltip:
    'Резерв необходим для того, чтобы избежать возможные задержки при приеме груза в случаях некорректного определения веса/габаритов отправителем. Он рассчитывается следующим образом: при стоимости доставки до 3000 рублей он равен 1000 рублей, при стоимости доставки более 3000 рублей — 30% от стоимости доставки.',
  PrintLabels: 'Завершить оформление',
  ConfirmAndPrint: 'Завершить оформление и распечатать накладную',
  WelcomeText: 'Мы рады, что вы решили отправить груз с нашей помощью',
  DownloadAwb: 'Скачать накладную',
  DownloadInvoice: 'Скачать инвойс',
  AttentionMiles:
    'Обращаем ваше внимание, что отправитель груза должен распечатать накладную. Отправление груза без распечатанной накладной невозможно!',
  AttentionMilesCargoForeign:
    'Обращаем ваше внимание, что отправитель груза должен распечатать документы (они содержат накладную и инвойс для таможенного оформления). Отправление груза без распечатанных документов  невозможно!',
  ClickPrint: 'Пожалуйста, ожидайте приезда курьера.',
  ClickPrintCargoForeign:
    'Пожалуйста, распечатайте документы и ожидайте приезда курьера.',
  WalkPrint:
    'Пожалуйста, сообщите номер заявки сотруднику сервисного отделения.',
  SuccessShipmentServiceDeskInfo:
    'Теперь вы можете прийти в выбранный офис {link} и осуществить отправку груза.',
  SuccessShipmentServiceDeskTell:
    'Чтобы отправить ваш груз - сообщите сотруднику офиса номер вашей заявки – ',
  OrderNumber: 'Номер вашей заявки',
  InPeriod: 'В период',
  TimeFrom: 'с',
  TimeTill: 'до',
  Time: 'Время',
  ApproximateTime: 'Время ориентировочное',
  Attention: 'Внимание!',
  PriceDifference:
    'Цена, полученная при первоначальном расчете, не совпадает с текущей ценой.',
  TransitDifference:
    'Транзитное время, полученное при первоначальном расчете, не совпадает с текущим транзитным временем.',
  PriceAndTransitDifference:
    'Цена и транзитное время, полученные при первоначальном расчете, не совпадают с текущими.',
  OnlinePaymentEmail:
    'Данный e-mail будет указан в чеке в поле “электронный адрес покупателя”, на него будет отправлен чек, а также уведомление в случае отмены.',
  ErrorOnlinePaymentWithPrinter:
    'Услуга "У меня/отправителя нет принтера, чтобы распечатать накладную" и способ оплаты онлайн несовместимы. При выборе способа оплаты онлайн снимается выбор c услуги "У меня/отправителя нет принтера, чтобы распечатать накладную"',
  timeRange: 'нет времени | с {from} до {to}',
  ServicePointHint:
    'Пожалуйста, выберите отделение DHL, из которого вам было бы удобно отправить груз',
  ChooseDepartment: 'Выбрать и продолжить',
  Backward: 'Назад',
  Open: 'Открыто',
  Closed: 'Закрыто',
  Weekend: 'Выходной',
  SelectPointDelivery: 'Выберите удобный для вас офис',
  SelectDepartment: 'Выбрать отделение',
  SelectDepartmentOther: 'Выбрать другое',
  NowLunch: 'сейчас обед',
  Lunch: 'Обед',
  NewValue: 'Новые значения',
  OldValue: 'Старые значения',
  ConfirmModalYes: 'Да',
  ConfirmModalNo: 'Нет',
  ConfirmModalTitleChangeAddress: 'Изменение пользовательского ввода',
  ConfirmModalChangeAddress:
    'Изменить адрес, который был введен ранее, на адрес отделения?',
  ConfirmModalPostalCod:
    'Изменить почтовый индекс, который был введен ранее, на почтовый индекс отделения?',
  DescriptionTooltipLocalCargo:
    'Отправка грузов по России <br> Для отправки лекарственных средств по России необходимо оформить сопроводительные документы. Чтобы получить консультацию, позвоните по номеру +7&nbsp;(495)&nbsp;961-10-67',
  DescriptionTooltipNotLocalCargo:
    'При отправлении некоторых грузов за границу может потребоваться дополнительная документация или согласование. Чтобы получить консультацию, позвоните по номеру {tellCity}',
  InvoiceBlockTitle: 'Информация о грузе',
  InvoiceBlockSubTitle:
    'Опишите отдельно каждое наименование вашего груза на русском и английском языках',
  InvoiceSelectPlaceholder: 'Цель экспорта',
  InvoiceListAddBtn: 'Добавить еще одно наименование ',
  InvoiceDescriptionRu: 'Описание наименования груза на русском языке',
  InvoiceDescriptionEn: 'Описание наименования груза на английском языке',
  InvoiceCommodityCode: 'Код ТН ВЭД',
  InvoiceCommodityCodeTip: 'Обратите внимание, что корректное указание кода ТН ВЭД является обязательным условием для успешного прохождения таможенного оформления вашего груза',
  InvoiceQuantity: 'Количество',
  InvoiceQuantityUnit: 'Единица измерения',
  InvoiceValue: 'Стоимость наименования',
  InvoiceCurrency: 'Код валюты',
  InvoiceWeight: 'Вес нетто, кг',
  InvoiceGrossWeight: 'Вес брутто, кг',
  InvoiceManufactureCountryCode: 'Где был произведен товар?',
  InvoiceBtnSave: 'Сохранить',
  InvoiceBtnCancel: 'Отмена',
  InvoiceBtnEdit: 'Редактировать',
  InvoiceBtnDelete: 'Удалить',
  InvoiceBtnRecover: 'Восстановить',
  InvoiceBtnCopy: 'Копировать',
  InvoiceTotalItem: 'Общее количество товарных позиций',
  InvoiceTotalPrice: 'Общая стоимость по инвойсу',
  InvoiceTotalWeight: 'Общий вес нетто',
  InvoiceTotalGrossWeight: 'Общий вес брутто',
  InvoiceTooltip:
    'Для отправки груза за границу требуется документ для таможенного декларирования – инвойс. Если у вас уже есть инвойс, не забудьте передать его вместе с грузом курьеру. Если у вас еще нет инвойса, создайте его на нашем сайте прямо сейчас. Для определенных видов товаров может также потребоваться дополнительная документация или согласование. Для отправки от физического лица требуется также копия паспорта (разворот первой страницы паспорта и страница с регистрацией). Чтобы получить консультацию, обратитесь к онлайн-консультанту или позвоните по номеру {tellCity}.',
  DeadLineForWeekend:
    'Датой отправления выбран ближайший доступный рабочий день. Однако есть возможность отправить груз в выходной день. Измените дату отправления при необходимости.',
  MessageNotAvailablePickUpTimeOne:
    'Сначала выберите отделение DHL для определения доступных временных интервалов.',
  MessageNotAvailablePickUpTimeTwo:
    'Выберите доступный временной интервал. Если временные интервалы отсутствуют, выберите другое отделение',
  RemindSenderNotCompanyClickCargoNoLocal:
    '<p>Для отправки груза за границу отправитель должен передать курьеру вместе с грузом следующие документы в распечатанном виде:</p><ul> <li>накладная DHL</li><li>инвойс</li><li>копия разворота первой страницы паспорта и страницы с регистрацией</li><li>иные сопроводительные документы (если необходимо)</li></ul> <p>Обращаем ваше внимание, в стране назначения возможны таможенные платежи и брокерские услуги, которые оплачивает получатель. За дополнительной информацией получатель может обратиться в местный офис DHL в стране назначения.</p>',
  RemindSenderCompanyClickCargoNoLocal:
    '<p>Для отправки груза отправитель должен передать курьеру вместе с грузом следующие документы в распечатанном виде:</p><ul> <li>накладная DHL</li><li>инвойс с печатью организации</li><li>иные сопроводительные документы (если необходимо)</li></ul> <p>Обращаем ваше внимание, в стране назначения возможны таможенные платежи и брокерские услуги, которые оплачивает получатель. За дополнительной информацией получатель может обратиться в местный офис DHL в стране назначения.</p>',
  RemindSenderNotCompanyWalkCargoNoLocal:
    '<p>Указанная цена действительна при отправке из сервисного отделения DHL.</p><p>Для отправки груза потребуются следующие документы:</p><ul> <li>накладная DHL</li><li>инвойс</li><li>копия разворота первой страницы паспорта и страницы с регистрацией (можно сделать в сервисном отделении DHL) </li><li>иные сопроводительные документы (если необходимо)</li></ul> <p>Пожалуйста, сообщите номер заказа сотруднику сервисного отделения и он распечатает для вас накладную и инвойс. Отправка может быть совершена при предъявлении паспорта</p><p>Обращаем ваше внимание, в стране назначения возможны таможенные платежи и брокерские услуги, которые оплачивает получатель. За дополнительной информацией получатель может обратиться в местный офис DHL в стране назначения.</p>',
  RemindSenderCompanyWalkCargoNoLocal:
    '<p>Указанная цена действительна при отправке из сервисного отделения DHL.</p><p>Для отправки груза потребуются следующие документы:</p><ul> <li>накладная DHL</li><li>инвойс с печатью организации</li><li>иные сопроводительные документы (если необходимо)</li></ul> <p>Пожалуйста, сообщите номер заказа сотруднику сервисного отделения и он распечатает для вас накладную. Отправка может быть совершена при предъявлении паспорта или водительского удостоверения</p><p>НОМЕР ЗАКАЗА</p><p>Обращаем ваше внимание, в стране назначения возможны таможенные платежи и брокерские услуги, которые оплачивает получатель. За дополнительной информацией получатель может обратиться в местный офис DHL в стране назначения.</p>',
  EmptyEmailMessage:
    'Вы не ввели email отправителя, на который мы хотели отправить транспортную накладную. Если вы не знаете этот email, просто нажмите далее.',
  ExtrasTitleMore: '',
  BrokerageServices: 'Возможны брокерские услуги в стране отправления, которые оплачиваются отправителем.',
  ServiceNotVailablOnline: 'Услуга недоступна при оплате онлайн',
  MutualSettlementMessage: 'Уважаемый клиент! Стоимость расчетов наличными между юридическими лицами превышает {cashLimitForCompanies} рублей. Пожалуйста, обратитесь в колл-центр для уточнения деталей.',
};
